import { Card, CardActions, CardContent, CardHeader, Container, IconButton, Stack, Tooltip, Typography } from "@mui/material"
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2

import MuiDashboardLeave from "./mui-dashboard-leave";
import MuiDashboardEmployes from "./mui-dashboard-employees";
import MuiDashboardEmployment from "./mui-dashboard-employment";
import { Masonry } from "@mui/lab";
import MuiDashboardLeaveSummary from "./mui-dashboard-leave-summary";


const MuiDashboard = () => {
    return (
        // <Stack sx={{ m: 1 }}>
        //     <Masonry columns={4} spacing={2}>
        //         <MuiDashboardLeave />
        //         <MuiDashboardEmployes />
        //         <MuiDashboardEmployment />
        //     </Masonry>
        // </Stack>

        <Stack sx={{ m: 1.5 }}>
            <Grid container spacing={2}
                columns={{ xs: 4, sm: 10, md: 12 }}
            >
                <Grid xs={4} sm={3} md={3}>
                    <MuiDashboardLeave />
                </Grid>
                <Grid xs={4} sm={7} md={6}>
                    <MuiDashboardEmployes />
                </Grid>
                <Grid xs={4} sm={5} md={3}>
                    <MuiDashboardLeaveSummary />
                </Grid>
                <Grid xs={4} sm={5} md={3}>
                    <MuiDashboardEmployment />
                </Grid>

            </Grid>
        </Stack>

    )
}

export default MuiDashboard